// extracted by mini-css-extract-plugin
export default {"cls1":"m2XgjwlL3g9LAo6Jko_d","cls2":"v4YbNjcWU3vF6ndG4ga4 m2XgjwlL3g9LAo6Jko_d"};